import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { getRequiredVerificationRoute } from '../utils/verification';
import { ROUTES } from '../config/appConfig';
import { normalizeUserRole, resolveSessionProfile } from '../utils/apiResponseUtils';
import { selectAccountRole } from '../store/slices/authSlice';

const ProtectedRoute = ({ children, allowedRoles, redirectTo, requireVerification = true, requirePhoneVerified = false }) => {
  const { isAuthenticated, user, restoring } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const location = useLocation();
  const userRole = normalizeUserRole(user);
  let selectCustomer = false;
  if (isAuthenticated && !restoring && userRole === 'driver' && allowedRoles?.length === 1 && allowedRoles[0] === 'user') {
    try { selectCustomer = resolveSessionProfile(user, 'user').role === 'user'; } catch { /* A driver-only account stays in its portal. */ }
  }
  React.useEffect(() => { if (selectCustomer) dispatch(selectAccountRole('user')); }, [selectCustomer, dispatch]);

  if (restoring) return <div role="status">Restoring your session?</div>;
  if (selectCustomer) return <div role="status">Opening customer portal...</div>;
  if (!isAuthenticated) {
    return <Navigate to={redirectTo || ROUTES.login} replace state={{ from: { pathname: location.pathname, search: location.search, state: location.state } }} />;
  }

  if (Array.isArray(allowedRoles) && allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    if (userRole === 'admin') {
      return <Navigate to={ROUTES.adminDashboard} replace />;
    }

    if (userRole === 'driver') {
      return <Navigate to={ROUTES.driverDashboard} replace />;
    }

    return <Navigate to={ROUTES.dashboard} replace />;
  }

  const verificationRoute = getRequiredVerificationRoute(user) || (requirePhoneVerified && user?.phoneVerified !== true ? ROUTES.phoneVerification : null);
  if (requireVerification && verificationRoute) {
    return <Navigate to={verificationRoute} replace state={{ from: {
      pathname: location.pathname, search: location.search, state: location.state,
    } }} />;
  }

  return children;
};

export default ProtectedRoute;
